import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";

/**
 * Utils
 */
import role from "@/config/roles";

/**
 * API
 */
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";

/**
 * VueX module for team infos and permissions.
 */
@Module({
	namespaced: true
})
export default class Team extends VuexModule {
	/** State */
	isLoading = false;
	team: GetOneTeamResponse | null = null;

	/** Mutations */
	@Mutation
	FETCH_TEAM(team: GetOneTeamResponse | null) {
		this.team = team;
		this.isLoading = false;
	}

	@Mutation
	SET_LOADING(loading: boolean) {
		this.isLoading = loading;
	}


	/** Actions */
	@Action
	async fetch(team: GetOneTeamResponse | null) {
		this.context.commit("SET_LOADING", true);
		this.context.commit("FETCH_TEAM", team);
	}

	/** Getters */
	// get permissions(): any {
	// 	return this.teamPermissions;
	// }

	get hasPermission() {
		return (p: number) => {
			if (this.team == null) {
				return false;
			}
			return role(this.team.access.permissions).hasPermission(p);
		};
	}
	get hasFeaturePermission() {
		return (p: number) => {
			if (this.team == null) {
				return false;
			}
			return role(this.team.access.features).hasFeaturePermission(p);
		};
	}
}